export default __webpack_public_path__ + "static/media/metamask-settings-highlight.4bd45b91.png";